import { links } from "../../utils/websiteData";
import "./nav.css";
import { useState } from "react";

const Nav = () => {
  const [activeNav, setActiveNav] = useState<number>(0);
  return (
    <nav>
      {links.map((link, index: number) => {
        const { title, href, icon } = link;
        return (
          <a
            key={index}
            title={title}
            href={href}
            className={index === activeNav ? "active" : ""}
            onClick={() => setActiveNav(index)}
          >
            {icon}
          </a>
        );
      })}
    </nav>
  );
};
export default Nav;
